module.exports = __webpack_public_path__ + "@/assets/img/logo-linkedin.e0695d69.png";